import { defineComponent as O, ref as a, watch as _, useId as w, onMounted as C, onUnmounted as I, openBlock as b, createElementBlock as B, createElementVNode as y, renderSlot as E, withDirectives as P, normalizeClass as S, vShow as $, nextTick as x } from "vue";
import { createPopper as H } from "@popperjs/core";
import { onClickOutside as M } from "@vueuse/core";
import { track as N } from "@ds/tracking/tracking";
const T = ["id"], U = ["id", "aria-describedby"], j = /* @__PURE__ */ O({
  name: "RevPopover",
  __name: "Popover",
  props: {
    contentClassNames: { default: "" },
    modifiers: { default: () => [] },
    position: { default: "top" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  emits: ["open", "close"],
  setup(p, { emit: k }) {
    const e = p, f = k, s = a(), r = a(), u = a(), t = a(!1), m = a(e.position), i = a(""), l = a("");
    let o = null;
    _(
      () => e.position,
      (n) => {
        o?.setOptions({ placement: n });
      }
    );
    const v = () => {
      N({
        action: "popover",
        context: {
          ...e,
          modifiers: e.modifiers,
          content: i.value,
          status: t.value ? "opened" : "closed",
          trigger: l.value
        }
      });
    };
    async function d() {
      if (!(t.value || !s.value || !u.value || !r.value)) {
        if (t.value = !0, f("open"), await x(), o === null) {
          const n = (e.triggerElementId && document.getElementById(e.triggerElementId)) ?? u.value;
          if (!n)
            return;
          o = H(n, r.value, {
            modifiers: [
              ...e.modifiers,
              {
                name: "actualPosition",
                enabled: !0,
                phase: "main",
                fn: ({ state: h }) => {
                  m.value = h.placement;
                }
              }
            ],
            placement: e.position
          });
        } else
          o.forceUpdate();
        v();
      }
    }
    const c = () => {
      t.value = !1, v(), f("close");
    };
    M(s, () => {
      e.shouldHideOnClickOutside && t.value && c();
    });
    const g = w();
    return C(async () => {
      i.value = `content-${g}`, l.value = `trigger-${g}`, e.shouldShowOnMount && (await document.fonts?.ready, d());
    }), I(() => {
      o !== null && (o.destroy(), o = null);
    }), (n, h) => (b(), B("span", {
      ref_key: "el",
      ref: s
    }, [
      y("span", {
        id: l.value,
        ref_key: "triggerEl",
        ref: u
      }, [
        E(n.$slots, "trigger", {
          ariaControls: i.value,
          ariaExpanded: t.value,
          ariaHaspopup: "true",
          hide: c,
          isOpen: t.value,
          show: d
        })
      ], 8, T),
      P(y("div", {
        id: i.value,
        ref_key: "contentEl",
        ref: r,
        "aria-describedby": l.value,
        class: S(p.contentClassNames)
      }, [
        E(n.$slots, "content", {
          hide: c,
          isOpen: t.value,
          position: m.value,
          show: d
        })
      ], 10, U), [
        [$, t.value]
      ])
    ], 512));
  }
});
export {
  j as default
};
